import { useWsRfq } from "@/lib/websocket/useRfq";
import Steps from "./Steps";
// import Button from "../Button";
import SelectQuoteRevision from "./SelectQuoteRevision";
import Overview from "./Overview";

export default function NavRFQ() {
  const rfq = useWsRfq();

  return (
    <nav className="min-w-[220px] max-w-[220px] h-full overflow-y-auto py-6 px-4 flex flex-col justify-between bg-slate-200">
      <div className="flex flex-col gap-4">
        <div className="font-bold text-slate-900">RFQ {rfq?.rfq_number}</div>
        <div className="font-bold text-slate-900 text-sm">
          {rfq?.contact.organization.name}
        </div>
        <SelectQuoteRevision />
        <div className="flex flex-col text-slate-900 text-sm bg-slate-100 p-2 rounded-sm">
          <div className="font-semibold">{rfq?.contact.name}</div>
          <div>{rfq?.contact.email}</div>
        </div>
        <Overview />
        <Steps />
      </div>
      {/* <Button
        className="w-[120px] bg-transparent self-center"
      >
        Download
      </Button> */}
    </nav>
  );
}
